import { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <ToastContainer />
        <NavMenu />
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
